/** Canonical expanded width shared by AppSidebar and AppShell.Sidebar. */
export const APP_SIDEBAR_EXPANDED_WIDTH = '280px';

/** Canonical collapsed width shared by AppSidebar and AppShell.Sidebar. */
export const APP_SIDEBAR_COLLAPSED_WIDTH = '68px';
